import React, { useState, useEffect } from 'react';
// import { hot } from 'react-hot-loader/root';
import GoogleMapReact from 'google-map-react';
import { ApolloProvider, Query } from 'react-apollo';
import { useInView } from 'react-intersection-observer';
import ListingMarker from '../Map/ListingMarker';
import WhiteMarker from '../WhiteMarker';
import { client } from '../client';
import { MAP_LISTINGS_QUERY } from '../../constants/queries';

// if (!document.querySelector('[name=csrf-token]').content) {
//   console.warning('Could not find csrf-token');
// }

const initialZoom = 13;

function PropertyNearbyThings({ center }) {
  const isSSR = typeof window === 'undefined';

  const [nearbyFilter, setNearbyFilter] = useState('activities');
  const [bounds, setBounds] = useState(null);
  const [activeMarker, setActiveMarker] = useState(null);
  const [showMap, setShowMap] = useState(false);

  const updateBounds = ({ bounds: newBounds }) => {
    setBounds([
      newBounds.sw.lng,
      newBounds.sw.lat,
      newBounds.ne.lng,
      newBounds.ne.lat,
    ]);
  };

  useEffect(() => {
    if (!isSSR) {
      const handleScroll = () => {
        if (window.scrollY >= 10) {
          setShowMap(true);
          document.removeEventListener('scroll', handleScroll);
        }
      };

      document.addEventListener('scroll', handleScroll);
      return () => document.removeEventListener('scroll', handleScroll);
    }
  }, [isSSR]);

  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  return (
    <section ref={ref} id="things" className="main-content-section">
      {inView && (
        <>
          <h3 className="section-title">Nearby Things to Do</h3>
          <ul className="property-nearby-nav">
            <li>
              <button
                aria-label="Show Nearby Activities"
                name="Show Nearby Activities"
                type="button"
                className={`btn btn--light btn--small property-nearby-map-btn ${
                  nearbyFilter === 'activities' ? 'btn--dark' : ''
                }`}
                onClick={() => setNearbyFilter('activities')}
              >
                Play
              </button>
            </li>
            <li>
              <button
                aria-label="Show Nearby Shopping"
                name="Show Nearby Shopping"
                type="button"
                className={`btn btn--light btn--small property-nearby-map-btn ${
                  nearbyFilter === 'shopping' ? 'btn--dark' : ''
                }`}
                onClick={() => setNearbyFilter('shopping')}
              >
                Shop
              </button>
            </li>
            <li>
              <button
                aria-label="Show Nearby Restaurants"
                name="Show Nearby Restaurants"
                type="button"
                className={`btn btn--light btn--small property-nearby-map-btn ${
                  nearbyFilter === 'restaurants' ? 'btn--dark' : ''
                }`}
                onClick={() => setNearbyFilter('restaurants')}
              >
                Dine
              </button>
            </li>
            <li>
              <button
                aria-label="Show Nearby Services"
                name="Show Nearby Services"
                type="button"
                className={`btn btn--light btn--small property-nearby-map-btn ${
                  nearbyFilter === 'services' ? 'btn--dark' : ''
                }`}
                onClick={() => setNearbyFilter('services')}
              >
                Hire
              </button>
            </li>
          </ul>

          {showMap && (
            <div className="property-nearby-map">
              <ApolloProvider client={client}>
                <Query
                  query={MAP_LISTINGS_QUERY}
                  variables={{
                    in_polygon: bounds || [],
                    is_type: nearbyFilter,
                  }}
                >
                  {({ data, loading, error }) => {
                    const listings =
                      data && data.listings ? data.listings.collection : [];

                    return (
                      <GoogleMapReact
                        bootstrapURLKeys={{
                          // @TODO: Add this to an environment variable or something
                          key: 'AIzaSyATvnQePj9OTTCZJ6VkugYM8dRGFPJ5HmQ',
                        }}
                        defaultCenter={center}
                        defaultZoom={initialZoom}
                        onChange={updateBounds}
                      >
                        <WhiteMarker
                          lat={center.lat}
                          lng={center.lng}
                          type="properties"
                          active
                        />
                        {listings.map(listing => (
                          <ListingMarker
                            key={listing.id}
                            lat={listing.latitude}
                            lng={listing.longitude}
                            listing={listing}
                            white_marker
                            type={listing.is_type}
                            changeActiveMarker={setActiveMarker}
                            activeMarker={activeMarker}
                          />
                        ))}
                      </GoogleMapReact>
                    );
                  }}
                </Query>
              </ApolloProvider>
            </div>
          )}
        </>
      )}
    </section>
  );
}

export default PropertyNearbyThings;
// export default hot(PropertyNearbyThings);
